import { GlossaryState } from 'common/modules/app/glossaries';

import { CommonGLKeys } from './common-types';
import { PlanListGLKeys } from './plan-list-types';
import { BoardGLKeys } from './board-types';
import { PlanDetailGLKeys } from './plan-detail-types';
import { ErrorsGLKeys } from './errors-types';
import { ContractGLKeys } from './contract-types';
import { HistoryGLKeys } from './history-types';
import { CompletionGLKeys } from './completion-types';

type GLKeys =
  | PlanListGLKeys
  | CommonGLKeys
  | BoardGLKeys
  | PlanDetailGLKeys
  | ContractGLKeys
  | HistoryGLKeys
  | ErrorsGLKeys
  | CompletionGLKeys
  | string;

/**
 * グロッサリ表示クラス
 *
 * GlossaryStateのラッパー
 */
export class Glossary {
  private static _instance: Glossary;
  private _glossary: GlossaryState;
  private constructor(glossary: GlossaryState) {
    this._glossary = glossary;
  }
  /**
   * グロッサリのインスタンス取得
   */
  public static instance(glossary: GlossaryState): Glossary {
    if (!this._instance) {
      this._instance = new Glossary(glossary);
    }
    // グロッサリ更新
    this._instance._glossary = glossary;
    return this._instance;
  }

  /**
   * グロッサリ取得
   */
  public glx(id: GLKeys): string {
    const str = this._glossary.glossaries[id];
    // 環境変数で設定されている場合に限り、グロッサリIDを表示する
    return str || (process.env.REACT_APP_DISPLAY_GL_ID ? `{${id}}` : '');
  }
}
